export default __webpack_public_path__ + "static/media/Seleção Site.4b289e30.svg";